import { setSessionData } from '../../../../infra/session';
import { afterSetUser, setUser } from '../../../../../app/auth/actions';
import { RudderstackTracker, USER_SIGNED_IN } from '../../../../infra/observability/rudderstack';
export var confirmUserLogin = function (payload) {
    setSessionData(payload.user);
    payload.dispatch(setUser(payload.user, payload.token));
    RudderstackTracker.getInstance().track(USER_SIGNED_IN);
    return afterSetUser(payload.user, payload.dispatch, payload.redirectObject);
};
